import { RouteConfig } from 'vue-router';
const BASE_PATH = 'views/government/bigDataCockpit';
const cockpit: Array<RouteConfig> = [
    {
        path: 'cockpit',
        name: 'cockpit',
        redirect: { name: 'bigDataCockpit' },
        meta: {
            menuMatch: 'bigDataCockpit',
        },
        component: () => import(`@/${BASE_PATH}/Main.vue`),
        children: [
            {
                path: 'big-data-cockpit',
                name: 'bigDataCockpit',
                component: () => import(`@/${BASE_PATH}/BigDataCockpit.vue`),
                meta: {
                    index: '2',//需和menuList中index字段对应
                    noBottom:true
                },
            },
        ],
    },
];
export default cockpit;